export default __webpack_public_path__ + "static/char-s-55-ja-25d23d3e71687729de085d6d7755ed56.png";